import { ref, computed, h, onMounted, onUnmounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-38f604aa"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "用于判断商品信息是否已成功上传到三方后台", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode(" 用于判断该商品是否处于可用状态 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 有效：可随版本发布 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 失效：该商品已停用 ")], -1));
const _hoisted_3 = {
  class: "elli-multiple-2"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1,
  class: "price-box flex-list"
};
const _hoisted_6 = {
  key: 0,
  class: "test-box"
};
const _hoisted_7 = {
  class: "badge-test"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "elli-multiple-2"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "statusColor wait"
}, null, -1));
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "statusColor inprogress"
}, null, -1));
const _hoisted_14 = {
  key: 2
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "statusColor refuse"
}, null, -1));
const _hoisted_16 = {
  class: "preLine"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, " 已驳回", -1));
const _hoisted_18 = {
  key: 3
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "statusColor success"
}, null, -1));
const _hoisted_20 = {
  key: 0
};
const _hoisted_21 = {
  key: 1
};
const _hoisted_22 = {
  key: 2
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  key: 2
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  key: 1
};
const _hoisted_28 = {
  key: 2
};
const _hoisted_29 = {
  key: 3
};
const _hoisted_30 = ["title"];
import { QuestionCircleOutlined, WarningFilled, SwapOutlined } from '@ant-design/icons-vue';
import { useStore } from '@/store';
import Empty from '@/components/Empty.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import useDetailHooks from '@/views/goodsManage/goodsSetting/hooks/useDetailHooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'TableContent',
  props: ['dataSource', 'columns', 'isGp', 'selectedRowKeys', 'tableLoading', 'prodChnl', 'isDefault', 'showSwapIcon'],
  emits: ['goDel', 'goOnline', 'goOffline', 'goUpd', 'onSelectChange', 'changeChnl'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const {
      prodTypeOptions
    } = useDetailHooks();
    const tableHeight = ref(500);
    const osList = [{
      label: '安卓',
      value: 1
    }, {
      label: 'ios',
      value: 2
    }];
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const locale = ref({
      emptyText: h(Empty, {
        description: !props.isGp ? '暂不支持配置非Google商品应用的内购商品' : '暂无数据'
      })
    }); // 缺省提示
    const goDel = record => {
      emits('goDel', record);
    };
    const goOnline = record => {
      emits('goOnline', record);
    };
    const goOffline = record => {
      emits('goOffline', record);
    };
    const goUpd = record => {
      emits('goUpd', record);
    };
    const onSelectChange = keyArr => {
      emits('onSelectChange', keyArr);
    };
    const getComingPrices = computed(() => record => {
      var _record$bizInfo, _record$bizInfo2;
      if (record !== null && record !== void 0 && (_record$bizInfo = record.bizInfo) !== null && _record$bizInfo !== void 0 && _record$bizInfo.upcomingPrices && record !== null && record !== void 0 && (_record$bizInfo2 = record.bizInfo) !== null && _record$bizInfo2 !== void 0 && (_record$bizInfo2 = _record$bizInfo2.upcomingPrices) !== null && _record$bizInfo2 !== void 0 && _record$bizInfo2.prodPrice) {
        return '即将生效价格:' + record.bizInfo.upcomingPrices.prodPriceCurrency + ' ' + record.bizInfo.upcomingPrices.prodPrice;
      }
      return '';
    });
    const toolText = computed(() => {
      return props.isDefault ? '点击切换美元价格' : '点击切换默认价格';
    });
    const changeDefault = () => {
      emits('changeChnl');
    };
    const calculateTableHeight = () => {
      const windowHeight = window.innerHeight;
      const otherHeight = 40 + 54 + 64 + 32 + 10 + 55 + 40 + 40 + 64 + 60;
      tableHeight.value = windowHeight - otherHeight;
    };
    onMounted(() => {
      calculateTableHeight();
      window.addEventListener('resize', calculateTableHeight);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', calculateTableHeight);
    });
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(_component_a_table, {
        bordered: "",
        columns: props.columns,
        "row-key": "id",
        "row-selection": {
          selectedRowKeys: props.selectedRowKeys,
          onChange: onSelectChange,
          preserveSelectedRowKeys: true
        },
        scroll: {
          x: 1800,
          y: tableHeight.value
        },
        "data-source": props.dataSource,
        locale: locale.value,
        pagination: false,
        loading: __props.tableLoading
      }, {
        headerCell: _withCtx(({
          column
        }) => [column.dataIndex === 'publishStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_a_tooltip, {
          placement: "top"
        }, {
          title: _withCtx(() => [_hoisted_1]),
          default: _withCtx(() => [_createTextVNode("   "), _createVNode(_unref(QuestionCircleOutlined), {
            class: "tableHeadIcon"
          })]),
          _: 1
        })], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_a_tooltip, {
          placement: "top"
        }, {
          title: _withCtx(() => [_hoisted_2]),
          default: _withCtx(() => [_createTextVNode("   "), _createVNode(_unref(QuestionCircleOutlined), {
            class: "tableHeadIcon"
          })]),
          _: 1
        })], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodPrice' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createTextVNode(" 默认价格 "), _createVNode(_component_a_tooltip, {
          placement: "top",
          title: _unref(toolText)
        }, {
          default: _withCtx(() => [props.showSwapIcon ? (_openBlock(), _createBlock(_unref(SwapOutlined), {
            key: 0,
            class: _normalizeClass({
              isUsd: !props.isDefault
            }),
            onClick: changeDefault
          }, null, 8, ["class"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["title"])], 64)) : _createCommentVNode("", true)]),
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _unref$find, _osList$find, _unref2, _unref3, _unref4, _unref5;
          return [['remark', 'prodId'].includes(column.dataIndex) ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "topLeft"
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record[column.dataIndex]), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(record[column.dataIndex]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'prodType' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString((_unref$find = _unref(prodTypeOptions).find(item => item.value === record.prodType)) === null || _unref$find === void 0 ? void 0 : _unref$find.label), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodPrice' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [!props.isDefault ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(record.usProdPriceCurrency) + " ", 1), _createElementVNode("span", null, _toDisplayString(record.usProdPrice) + " ", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_withDirectives(_createElementVNode("span", null, _toDisplayString(record.prodPriceCurrency) + " ", 513), [[_vShow, record.prodPriceCurrency]]), record.testStatus ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createTextVNode(_toDisplayString(record.prodPrice) + " ", 1), _createElementVNode("span", _hoisted_7, [_createVNode(SvgIcon, {
            "icon-class": "isTest",
            "class-name": "test-icon"
          })])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(record.prodPrice), 1), _createVNode(_component_a_tooltip, null, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getComingPrices)(record)), 1)]),
            default: _withCtx(() => {
              var _record$bizInfo3;
              return [record.bizInfo && record.bizInfo.upcomingPrices && !(record !== null && record !== void 0 && (_record$bizInfo3 = record.bizInfo) !== null && _record$bizInfo3 !== void 0 && (_record$bizInfo3 = _record$bizInfo3.upcomingPrices) !== null && _record$bizInfo3 !== void 0 && _record$bizInfo3.isDeleted) ? (_openBlock(), _createBlock(_unref(WarningFilled), {
                key: 0,
                style: {
                  "color": "#f9ab13",
                  "margin-left": "6px"
                }
              })) : _createCommentVNode("", true)];
            }),
            _: 2
          }, 1024)]))]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodName' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 3,
            placement: "topLeft"
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.prodName), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_9, _toDisplayString(record.prodName), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'os' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 4
          }, [_createTextVNode(_toDisplayString((_osList$find = osList.find(item => item.value === record.os)) === null || _osList$find === void 0 ? void 0 : _osList$find.label), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'approvalStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 5
          }, [record.approvalStatus === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_10, [_hoisted_11, _createTextVNode(" 待提交 ")])) : _createCommentVNode("", true), record.approvalStatus === 10 ? (_openBlock(), _createElementBlock("span", _hoisted_12, [_hoisted_13, _createTextVNode(" 审核中 ")])) : _createCommentVNode("", true), record.approvalStatus === 20 ? (_openBlock(), _createElementBlock("span", _hoisted_14, [_hoisted_15, _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_16, _toDisplayString(record.rejectMsg), 1)]),
            default: _withCtx(() => [_hoisted_17]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true), record.approvalStatus === 30 ? (_openBlock(), _createElementBlock("span", _hoisted_18, [_hoisted_19, _createTextVNode(" 已通过 ")])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), column.dataIndex === 'publishStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 6
          }, [record.publishStatus === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_20, "--")) : _createCommentVNode("", true), record.publishStatus === 10 ? (_openBlock(), _createElementBlock("span", _hoisted_21, [_createVNode(SvgIcon, {
            class: "tableIcon",
            "icon-class": "send_success"
          }), _createTextVNode(" 成功 ")])) : _createCommentVNode("", true), record.publishStatus === 20 ? (_openBlock(), _createElementBlock("span", _hoisted_22, [_createVNode(SvgIcon, {
            class: "tableIcon",
            "icon-class": "send_fail"
          }), _createTextVNode(" 失败 ")])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 7
          }, [record.prodStatus === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_23, "--")) : _createCommentVNode("", true), record.prodStatus === 10 ? (_openBlock(), _createElementBlock("span", _hoisted_24, [_createVNode(SvgIcon, {
            class: "tableIcon",
            "icon-class": "send_success"
          }), _createTextVNode(" 有效 ")])) : _createCommentVNode("", true), record.prodStatus === 20 ? (_openBlock(), _createElementBlock("span", _hoisted_25, [_createVNode(SvgIcon, {
            class: "tableIcon",
            "icon-class": "outline"
          }), _createTextVNode(" 失效 ")])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), column.dataIndex === 'optType' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 8
          }, [record.optType === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_26, "新增")) : _createCommentVNode("", true), record.optType === 10 ? (_openBlock(), _createElementBlock("span", _hoisted_27, "修改")) : _createCommentVNode("", true), record.optType === 20 ? (_openBlock(), _createElementBlock("span", _hoisted_28, "停用")) : _createCommentVNode("", true), record.optType === 30 ? (_openBlock(), _createElementBlock("span", _hoisted_29, "启用")) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), column.dataIndex === 'approver' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 9,
            placement: "right"
          }, {
            title: _withCtx(() => {
              var _record$bizInfo4;
              return [_createTextVNode(_toDisplayString((_record$bizInfo4 = record.bizInfo) !== null && _record$bizInfo4 !== void 0 && _record$bizInfo4.approvalUsers ? record.bizInfo.approvalUsers : '--'), 1)];
            }),
            default: _withCtx(() => {
              var _record$bizInfo5, _record$bizInfo6;
              return [_createElementVNode("span", {
                title: (_record$bizInfo5 = record.bizInfo) !== null && _record$bizInfo5 !== void 0 && _record$bizInfo5.approvalUsers ? record.bizInfo.approvalUsers : '-',
                style: {
                  "display": "inline-block",
                  "max-width": "90%",
                  "white-space": "nowrap",
                  "overflow": "hidden",
                  "text-overflow": "ellipsis"
                }
              }, _toDisplayString((_record$bizInfo6 = record.bizInfo) !== null && _record$bizInfo6 !== void 0 && _record$bizInfo6.approvalUsers ? record.bizInfo.approvalUsers : '--'), 9, _hoisted_30)];
            }),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 10
          }, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
            disabled: record.modStatus === 0,
            class: "tableBtn",
            type: "link",
            onClick: $event => goUpd(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
            _: 2
          }, 1032, ["disabled", "onClick"])), [[_directive_permission, {
            permissionValue: 'goodsSetting',
            permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
          }]]), record.approvalStatus !== 30 ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            disabled: record.approvalStatus === 10 || record.replicaStatus === 1,
            class: "tableBtn",
            type: "link",
            onClick: $event => goDel(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除 ")]),
            _: 2
          }, 1032, ["disabled", "onClick"])), [[_directive_permission, {
            permissionValue: 'goodsSetting',
            permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
          }]]) : _createCommentVNode("", true), record.prodStatus === 10 ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            disabled: record.replicaStatus === 1,
            class: "tableBtn",
            type: "link",
            onClick: $event => goOffline(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 停用 ")]),
            _: 2
          }, 1032, ["disabled", "onClick"])), [[_directive_permission, {
            permissionValue: 'goodsSetting',
            permissionArr: (_unref4 = _unref(userInfo)) === null || _unref4 === void 0 ? void 0 : _unref4.permissions
          }]]) : _createCommentVNode("", true), record.prodStatus === 20 ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            key: 2,
            disabled: record.replicaStatus === 1,
            class: "tableBtn",
            type: "link",
            onClick: $event => goOnline(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 启用 ")]),
            _: 2
          }, 1032, ["disabled", "onClick"])), [[_directive_permission, {
            permissionValue: 'goodsSetting',
            permissionArr: (_unref5 = _unref(userInfo)) === null || _unref5 === void 0 ? void 0 : _unref5.permissions
          }]]) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "row-selection", "scroll", "data-source", "locale", "loading"]);
    };
  }
});